import React, { useContext, useEffect, useState } from "react";
import { ErrorMessage, Formik } from "formik";
import {
  Alert,
  Button,
  Form,
  Spinner,
  Card,
  Row,
  Col,
  Table,
  Accordion,
} from "react-bootstrap";
import moment from "moment";
import * as Yup from "yup";
import { getInputClasses } from "../../../_utils/getInputclasses";
import AlertError from "../../../components/AlertError";
import { Divider } from "@material-ui/core";
import { update as updateCase } from "../../services/hospitalizationcrud";
import {getAllByCase, save} from "../../services/binnaclesService";
import { GetUser } from "../../../../_metronic/_helpers";

import CaseContext from "../../../contexts/CaseContext";
import BlockCaseContext from "../../../contexts/BlockCaseContext";
import {useHistory} from "react-router-dom";
import $ from 'jquery';
import {isNotEmpty} from "../../../_utils/checkObjectEmpty";

export const Binnacle = (props) => {
  return (
    <>
      <Card>
        <Card.Header>
          <Accordion.Toggle
            as={Button}
            variant="link"
            eventKey={props.eventKey}
          >
            Bitacora de Comentarios
          </Accordion.Toggle>
          {props.hasError && (
            <i className="fa fa-exclamation-triangle"
               style={{ position: "absolute", right: "40px", marginTop: "10px", color: "#dc3545" }}
               title="Debes guardar un comentario antes de continuar"
            ></i>
          )}
          <i className={`fa ${props.icon}`} style={{position:"absolute", right:"0", marginRight:"15px", marginTop:"10px" }}></i>
        </Card.Header>
        <Accordion.Collapse eventKey={props.eventKey}>
          <Card.Body>
            <ContentBinnacle {...props} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
};

export const ContentBinnacle = (props) => {
  return (
    <>
      <Alert
        variant="dark"
        className="text-center mt-4"
        style={{ fontSize: "14px" }}
      >
        Bitacora de Comentarios
      </Alert>

      <Card>
        <Card.Body>
          <FormBinnacle {...props} />
        </Card.Body>
      </Card>
    </>
  );
};

export const FormBinnacle = (props) => {
  const { data } = props;
  const { slug } = props.match?.params || props;
  const { hideButton = false, hideReason = true } = props;

  const [initialBinnacle, setInitialBinnacle] = useState({
    comment: props.comment || "",
    event: props.eventStage || "",
    reason: "",
  });
  const [commentNotRequired, setCommentNotRequired] = useState(false)
  const [userAuth] = useState({ ...GetUser().user });
  const [binnacles, setBinnacles] = useState([]);
  const [caseRecord, setCaseRecord] = useContext(CaseContext);
  const [, setShouldBlockCase] = useContext(BlockCaseContext);

  const history = useHistory();

  useEffect(() => {
      if (isNotEmpty(data)) {
          getAllByCase(data.id)
              .then(data => setBinnacles(data.data));
      }
    loadJQuery();
  }, [data]);

  const loadJQuery = () => {
    $("#btn_save_comment").on('click', function(evt) {
      if (evt.originalEvent === undefined) {
        setCommentNotRequired(true);
      } else {
        setCommentNotRequired(false);
      }
    });
  }

  const onSubmit = (values, { setStatus, setSubmitting, resetForm }) => {
    values.userId = userAuth.idUser;
    values.event = props.eventStage || "";
    setTimeout(() => {
      let caseType;

      if (!hideReason) {
        caseType = "Cancelado";
      } else {
        caseType = props?.data?.caseType || document.getElementById('caseTypeOther')?.value || document.getElementById('caseType')?.value || props.eventStage;
      }

      save({
        ...values,
        caseType: caseType,
        axaCategories: props.data.axaCategories,
        movementsMedicalOpinion: props.data.movementsMedicalOpinion,
        complexCase: props.data.complexCase,
      }, slug)
        .then( response => {
          setShouldBlockCase(false);
          setInitialBinnacle({ comment: "", event: props.eventStage || "" });
          getAllByCase(data.id)
            .then(data => setBinnacles(data.data));
          resetForm();
          console.log("comment saved");
          window.wasCommented = true;
          if (props.onCommentSaved) props.onCommentSaved();

          if (!hideReason) {
            updateCase({caseType: "Cancelado", caseStatusId: 10}, props.data.id).then((response) => {
              setCaseRecord({ ...caseRecord, caseType: "Cancelado", caseStatusId: 10});
              setShouldBlockCase(false);

              history.push("/cancelaciones");
            });
          }
        })
        .catch( err => setStatus(`Ocurrio algun error al guardar`));
      setSubmitting(false);
    }, 1000);
  }

  return (
    <>
      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th>Usuario</th>
            <th>Evento</th>
            <th>Tipo de tramite</th>
            <th>Fecha Hora (DD/MM/AAAA HH:MM:SS)</th>
            <th>Comentarios</th>
          </tr>
        </thead>
        <tbody>
          {binnacles?.map( (binnacle, idx) => (
            <tr key={idx} hidden={binnacle.comment.trim() === ""}>
              <td>{binnacle.user?.userName}</td>
              <td>{binnacle.event}</td>
              <td>{binnacle.caseType}</td>
              <td>{moment(binnacle.createdAt).format('DD/MM/YYYY HH:mm:ss A')}</td>
              <td>{binnacle.comment}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Divider className="mt-5 mb-5" />
      <Formik initialValues={{...initialBinnacle}}
              enableReinitialize={true}
              onSubmit={onSubmit}
              validationSchema={() => Yup.lazy((values) => {
                  return Yup.object().shape({
                      comment: hideReason && commentNotRequired ? null : Yup.string()
                          .required("El campo es requerido")
                          .test('required', 'El campo es requerido',
                              (item) => typeof values.comment !== 'undefined' && values.comment.trim() !== ''
                          ),
                      reason: hideReason ? null : Yup.string()
                          .required("El campo es requerido"),
                  });
              })}>
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          status,
          isSubmitting,
        }) => (
          <>
            <AlertError status={status} />

            <Form onSubmit={handleSubmit}>
              <Row hidden={props.disabledAll}>
                <Col hidden={hideReason}>
                  <Form.Group controlId="reason">
                    <Form.Label>Motivo *</Form.Label>
                    <Form.Control
                        disabled={props.disabledAll}
                        as="select"
                        name="reason"
                        value={values.document_type}
                        onChange={handleChange}
                        className={`${getInputClasses(
                            touched,
                            errors,
                            "reason"
                        )}`}
                    >
                      <option value="">SELECCIONA UNA OPCIÓN...</option>
                      <option value="Folio Duplicado">Folio Duplicado</option>
                      <option value="Datos Erróneos Asegurado">Datos Erróneos Asegurado</option>
                      <option value="A petición del Asegurado">A petición del Asegurado</option>
                      <option value="Sin Seguimiento Hospital">Sin Seguimiento Hospital</option>
                      <option value="Error en Captura">Error en Captura</option>
                      <option value="Otro Motivo">Otro Motivo</option>
                    </Form.Control>
                    <ErrorMessage name="reason">
                      {(msg) => (
                          <Form.Control.Feedback type="invalid">
                            {msg}
                          </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="comment">
                    <Form.Label>Agrega tu Comentario *</Form.Label>
                    <Form.Control
                      disabled={props.disabledAll}
                      type="text"
                      name="comment"
                      value={values.comment}
                      onChange={handleChange}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "comment"
                      )}`}
                    />
                    <ErrorMessage name="comment">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>
              <Button variant="primary" id="btn_save_comment" type="submit" disabled={isSubmitting} hidden={hideButton}>
                {isSubmitting && (
                  <Spinner
                    as="span"
                    animation="border"
                    variant="dark"
                    size="sm"
                  />
                )}
                Guardar Comentario
              </Button>

              <Button variant="danger" type="submit" disabled={isSubmitting} hidden={hideReason}>
                {isSubmitting && (
                    <Spinner
                        as="span"
                        animation="border"
                        variant="dark"
                        size="sm"
                    />
                )}
                Cancelar
              </Button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};
